var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"chart"},[_c('p',{staticClass:"chart__text chart__text--green"},[_vm._v(" Correct: "+_vm._s(_vm.reportData.correct)+"% ")]),_c('p',{staticClass:"chart__text chart__text--blue"},[_vm._v(" Progress: "+_vm._s(_vm.reportData.progress)+"% ")]),_c('ProgressScore',{attrs:{"data":[_vm.reportData.correct, _vm.reportData.progress]}})],1),_c('DataTable',{attrs:{"row-key":"lessonId","data":_vm.computedData,"columns":_vm.tableColumns,"loading":_vm.pending,"sortable":_vm.sortable,"sortable-columns":[
      'unit',
      'name',
      'percentage0',
      'percentage1',
      'percentage2',
      'percentage3'
    ]},scopedSlots:_vm._u([{key:"activity1",fn:function(ref){
    var row = ref.row;
return [_vm._v(" "+_vm._s(((row.percentage0) + "%"))+" ")]}},{key:"activity2",fn:function(ref){
    var row = ref.row;
return [_vm._v(" "+_vm._s(((row.percentage1) + "%"))+" ")]}},{key:"activity3",fn:function(ref){
    var row = ref.row;
return [_vm._v(" "+_vm._s(((row.percentage2) + "%"))+" ")]}},{key:"activity4",fn:function(ref){
    var row = ref.row;
return [_vm._v(" "+_vm._s(((row.percentage3) + "%"))+" ")]}},{key:"eye",fn:function(ref){
    var row = ref.row;
return [_c('div',{staticClass:"scores"},[_c('router-link',{staticClass:"eye-btn",attrs:{"to":("/report-generator/lesson/" + (row.lessonId))}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }